/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, useEffect, useState } from 'react';
import clsx from 'clsx';
import { TextComponent, Image, Button, Types, size } from '@marriott/mi-ui-library';
import { useSession } from '@marriott/mi-headless-utils';
import { useClientEnvVarsStore } from '@marriott/mi-store-utils';

import { IMAGE_CACHE_DOMAIN } from '../../constants/CommonConstants';
import { constructCobrandCTAUrl } from '../../utils/OfferUtils';
import { formCustomClickTrackValue } from '../../utils/CommonUtils';

import { TnCLinksWithModal } from '../TnCLinksWithModal';
import { StyledCardArt } from './CardArt.styles';
import { CardArtProps } from './CardArt.types';

export const CardArt: FC<CardArtProps> = props => {
  const { offersData, model } = props;
  const [ctaUrl, setCtaUrl] = useState('');
  const { datalayer } = useSession();
  const cobrandOfferData = offersData?.responseObject?.offers?.[0];
  const trackingProperties = { ...model?.trackingProperties };
  Object.assign(trackingProperties, {
    trackingDescription: cobrandOfferData?.trackingValue,
    location: cobrandOfferData?.ctaLabel,
  });
  const openInNewtab: 'External' | 'Internal' = cobrandOfferData?.ctaExtInd ? 'External' : 'Internal';
  const customClickTrackValue = formCustomClickTrackValue(trackingProperties, openInNewtab);
  const { envVarsObject } = useClientEnvVarsStore();
  const imageDomain = envVarsObject?.['UXL_IMAGE_CACHE_DOMAIN'] ?? IMAGE_CACHE_DOMAIN;
  const logoImageSrc = cobrandOfferData?.media?.secondaryImage?.imageSrc
    ? imageDomain + cobrandOfferData.media.secondaryImage.imageSrc
    : '';
  const alignCenter = props?.contentAlignment === 'center';

  useEffect(() => {
    // Only run on client
    if (typeof window !== 'undefined') {
      const url = constructCobrandCTAUrl(cobrandOfferData, datalayer) || '';
      setCtaUrl(url);
    }
  }, [cobrandOfferData, datalayer]);

  return (
    <StyledCardArt>
      <div className={`card-art-wrapper ${alignCenter ? 'align-center' : ''}`}>
        {logoImageSrc && (
          <div className="credit-card-container-wrapper">
            <div className="credit-card-container">
              <Image
                title={cobrandOfferData?.media?.secondaryImage?.title}
                customClass="logo-image"
                loading="eager"
                defaultImageURL={logoImageSrc}
                altText={cobrandOfferData?.media?.secondaryImage?.alternateDescription}
                dynamic={false}
              ></Image>
            </div>
          </div>
        )}
        <TextComponent
          header={cobrandOfferData?.title}
          componentId={model?.componentId || ''}
          headerFontSize={size.medium}
          styleclass={'p-0 text-details'}
          customClass="text-block"
          contentAlignment={alignCenter ? 'center' : 'left'}
          descriptionText={cobrandOfferData?.descriptionTeaser}
          showLessDesc={false}
          descriptionFontSize={size.medium}
        />
        {cobrandOfferData?.tncCta?.length > 0 && (
          <TnCLinksWithModal
            tncCta={cobrandOfferData.tncCta}
            trackingProperties={trackingProperties}
            wrapperClassName="tnc-links__wrapper--center-mobile"
          />
        )}
        {cobrandOfferData?.ctaLabel !== null &&
          cobrandOfferData?.ctaLabel !== undefined &&
          cobrandOfferData?.ctaLabel !== '' && (
            <Button
              isLink={true}
              type={Types.ButtonTypeVariation.Button}
              href={ctaUrl}
              className={clsx(`m-button-primary mt-4 pt-2 click-event-enabled`, {
                'm-button-external': cobrandOfferData?.ctaExtInd,
              })}
              target={cobrandOfferData?.ctaExtInd ? '_blank' : '_self'}
              trackingProperties={trackingProperties}
              custom_click_track_value={customClickTrackValue}
            >
              {cobrandOfferData?.ctaLabel}
            </Button>
          )}
      </div>
    </StyledCardArt>
  );
};
